export const Stops = {
  "101": "Van Cortlandt Park-242 St",
  "101N": "Van Cortlandt Park-242 St",
  "101S": "Van Cortlandt Park-242 St",
  "103": "238 St",
  "103N": "238 St",
  "103S": "238 St",
  "104": "231 St",
  "104N": "231 St",
  "104S": "231 St",
  "106": "Marble Hill-225 St",
  "106N": "Marble Hill-225 St",
  "106S": "Marble Hill-225 St",
  "107": "215 St",
  "107N": "215 St",
  "107S": "215 St",
  "108": "207 St",
  "108N": "207 St",
  "108S": "207 St",
  "109": "Dyckman St",
  "109N": "Dyckman St",
  "109S": "Dyckman St",
  "110": "191 St",
  "110N": "191 St",
  "110S": "191 St",
  "111": "181 St",
  "111N": "181 St",
  "111S": "181 St",
  "112": "168 St-Washington Hts",
  "112N": "168 St-Washington Hts",
  "112S": "168 St-Washington Hts",
  "113": "157 St",
  "113N": "157 St",
  "113S": "157 St",
  "114": "145 St",
  "114N": "145 St",
  "114S": "145 St",
  "115": "137 St-City College",
  "115N": "137 St-City College",
  "115S": "137 St-City College",
  "116": "125 St",
  "116N": "125 St",
  "116S": "125 St",
  "117": "116 St-Columbia University",
  "117N": "116 St-Columbia University",
  "117S": "116 St-Columbia University",
  "118": "Cathedral Pkwy (110 St)",
  "118N": "Cathedral Pkwy (110 St)",
  "118S": "Cathedral Pkwy (110 St)",
  "119": "103 St",
  "119N": "103 St",
  "119S": "103 St",
  "120": "96 St",
  "120N": "96 St",
  "120S": "96 St",
  "121": "86 St",
  "121N": "86 St",
  "121S": "86 St",
  "122": "79 St",
  "122N": "79 St",
  "122S": "79 St",
  "123": "72 St",
  "123N": "72 St",
  "123S": "72 St",
  "124": "66 St-Lincoln Center",
  "124N": "66 St-Lincoln Center",
  "124S": "66 St-Lincoln Center",
  "125": "59 St-Columbus Circle",
  "125N": "59 St-Columbus Circle",
  "125S": "59 St-Columbus Circle",
  "126": "50 St",
  "126N": "50 St",
  "126S": "50 St",
  "127": "Times Sq-42 St",
  "127N": "Times Sq-42 St",
  "127S": "Times Sq-42 St",
  "128": "34 St-Penn Station",
  "128N": "34 St-Penn Station",
  "128S": "34 St-Penn Station",
  "129": "28 St",
  "129N": "28 St",
  "129S": "28 St",
  "130": "23 St",
  "130N": "23 St",
  "130S": "23 St",
  "131": "18 St",
  "131N": "18 St",
  "131S": "18 St",
  "132": "14 St",
  "132N": "14 St",
  "132S": "14 St",
  "133": "Christopher St-Stonewall",
  "133N": "Christopher St-Stonewall",
  "133S": "Christopher St-Stonewall",
  "134": "Houston St",
  "134N": "Houston St",
  "134S": "Houston St",
  "135": "Canal St",
  "135N": "Canal St",
  "135S": "Canal St",
  "136": "Franklin St",
  "136N": "Franklin St",
  "136S": "Franklin St",
  "137": "Chambers St",
  "137N": "Chambers St",
  "137S": "Chambers St",
  "138": "WTC Cortlandt",
  "138N": "WTC Cortlandt",
  "138S": "WTC Cortlandt",
  "139": "Rector St",
  "139N": "Rector St",
  "139S": "Rector St",
  "140": "South Ferry Loop",
  "140N": "South Ferry Loop",
  "140S": "South Ferry Loop",
  "142": "South Ferry",
  "142N": "South Ferry",
  "142S": "South Ferry",
  "201": "Wakefield-241 St",
  "201N": "Wakefield-241 St",
  "201S": "Wakefield-241 St",
  "204": "Nereid Av",
  "204N": "Nereid Av",
  "204S": "Nereid Av",
  "205": "233 St",
  "205N": "233 St",
  "205S": "233 St",
  "206": "225 St",
  "206N": "225 St",
  "206S": "225 St",
  "207": "219 St",
  "207N": "219 St",
  "207S": "219 St",
  "208": "Gun Hill Rd",
  "208N": "Gun Hill Rd",
  "208S": "Gun Hill Rd",
  "209": "Burke Av",
  "209N": "Burke Av",
  "209S": "Burke Av",
  "210": "Allerton Av",
  "210N": "Allerton Av",
  "210S": "Allerton Av",
  "211": "Pelham Pkwy",
  "211N": "Pelham Pkwy",
  "211S": "Pelham Pkwy",
  "212": "Bronx Park East",
  "212N": "Bronx Park East",
  "212S": "Bronx Park East",
  "213": "E 180 St",
  "213N": "E 180 St",
  "213S": "E 180 St",
  "214": "West Farms Sq-E Tremont Av",
  "214N": "West Farms Sq-E Tremont Av",
  "214S": "West Farms Sq-E Tremont Av",
  "215": "174 St",
  "215N": "174 St",
  "215S": "174 St",
  "216": "Freeman St",
  "216N": "Freeman St",
  "216S": "Freeman St",
  "217": "Simpson St",
  "217N": "Simpson St",
  "217S": "Simpson St",
  "218": "Intervale Av",
  "218N": "Intervale Av",
  "218S": "Intervale Av",
  "219": "Prospect Av",
  "219N": "Prospect Av",
  "219S": "Prospect Av",
  "220": "Jackson Av",
  "220N": "Jackson Av",
  "220S": "Jackson Av",
  "221": "3 Av-149 St",
  "221N": "3 Av-149 St",
  "221S": "3 Av-149 St",
  "222": "149 St-Grand Concourse",
  "222N": "149 St-Grand Concourse",
  "222S": "149 St-Grand Concourse",
  "224": "135 St",
  "224N": "135 St",
  "224S": "135 St",
  "225": "125 St",
  "225N": "125 St",
  "225S": "125 St",
  "226": "116 St",
  "226N": "116 St",
  "226S": "116 St",
  "227": "Central Park North (110 St)",
  "227N": "Central Park North (110 St)",
  "227S": "Central Park North (110 St)",
  "228": "Park Place",
  "228N": "Park Place",
  "228S": "Park Place",
  "229": "Fulton St",
  "229N": "Fulton St",
  "229S": "Fulton St",
  "230": "Wall St",
  "230N": "Wall St",
  "230S": "Wall St",
  "231": "Clark St",
  "231N": "Clark St",
  "231S": "Clark St",
  "232": "Borough Hall",
  "232N": "Borough Hall",
  "232S": "Borough Hall",
  "233": "Hoyt St",
  "233N": "Hoyt St",
  "233S": "Hoyt St",
  "234": "Nevins St",
  "234N": "Nevins St",
  "234S": "Nevins St",
  "235": "Atlantic Av-Barclays Ctr",
  "235N": "Atlantic Av-Barclays Ctr",
  "235S": "Atlantic Av-Barclays Ctr",
  "236": "Bergen St",
  "236N": "Bergen St",
  "236S": "Bergen St",
  "237": "Grand Army Plaza",
  "237N": "Grand Army Plaza",
  "237S": "Grand Army Plaza",
  "238": "Eastern Pkwy-Brooklyn Museum",
  "238N": "Eastern Pkwy-Brooklyn Museum",
  "238S": "Eastern Pkwy-Brooklyn Museum",
  "239": "Franklin Av-Medgar Evers College",
  "239N": "Franklin Av-Medgar Evers College",
  "239S": "Franklin Av-Medgar Evers College",
  "241": "President St-Medgar Evers College",
  "241N": "President St-Medgar Evers College",
  "241S": "President St-Medgar Evers College",
  "242": "Sterling St",
  "242N": "Sterling St",
  "242S": "Sterling St",
  "243": "Winthrop St",
  "243N": "Winthrop St",
  "243S": "Winthrop St",
  "244": "Church Av",
  "244N": "Church Av",
  "244S": "Church Av",
  "245": "Beverly Rd",
  "245N": "Beverly Rd",
  "245S": "Beverly Rd",
  "246": "Newkirk Av-Little Haiti",
  "246N": "Newkirk Av-Little Haiti",
  "246S": "Newkirk Av-Little Haiti",
  "247": "Flatbush Av-Brooklyn College",
  "247N": "Flatbush Av-Brooklyn College",
  "247S": "Flatbush Av-Brooklyn College",
  "248": "Nostrand Av",
  "248N": "Nostrand Av",
  "248S": "Nostrand Av",
  "249": "Kingston Av",
  "249N": "Kingston Av",
  "249S": "Kingston Av",
  "250": "Crown Hts-Utica Av",
  "250N": "Crown Hts-Utica Av",
  "250S": "Crown Hts-Utica Av",
  "251": "Sutter Av-Rutland Rd",
  "251N": "Sutter Av-Rutland Rd",
  "251S": "Sutter Av-Rutland Rd",
  "252": "Saratoga Av",
  "252N": "Saratoga Av",
  "252S": "Saratoga Av",
  "253": "Rockaway Av",
  "253N": "Rockaway Av",
  "253S": "Rockaway Av",
  "254": "Junius St",
  "254N": "Junius St",
  "254S": "Junius St",
  "255": "Pennsylvania Av",
  "255N": "Pennsylvania Av",
  "255S": "Pennsylvania Av",
  "256": "Van Siclen Av",
  "256N": "Van Siclen Av",
  "256S": "Van Siclen Av",
  "257": "New Lots Av",
  "257N": "New Lots Av",
  "257S": "New Lots Av",
  "301": "Harlem-148 St",
  "301N": "Harlem-148 St",
  "301S": "Harlem-148 St",
  "302": "145 St",
  "302N": "145 St",
  "302S": "145 St",
  "401": "Woodlawn",
  "401N": "Woodlawn",
  "401S": "Woodlawn",
  "402": "Mosholu Pkwy",
  "402N": "Mosholu Pkwy",
  "402S": "Mosholu Pkwy",
  "405": "Bedford Park Blvd-Lehman College",
  "405N": "Bedford Park Blvd-Lehman College",
  "405S": "Bedford Park Blvd-Lehman College",
  "406": "Kingsbridge Rd",
  "406N": "Kingsbridge Rd",
  "406S": "Kingsbridge Rd",
  "407": "Fordham Rd",
  "407N": "Fordham Rd",
  "407S": "Fordham Rd",
  "408": "183 St",
  "408N": "183 St",
  "408S": "183 St",
  "409": "Burnside Av",
  "409N": "Burnside Av",
  "409S": "Burnside Av",
  "410": "176 St",
  "410N": "176 St",
  "410S": "176 St",
  "411": "Mt Eden Av",
  "411N": "Mt Eden Av",
  "411S": "Mt Eden Av",
  "412": "170 St",
  "412N": "170 St",
  "412S": "170 St",
  "413": "167 St",
  "413N": "167 St",
  "413S": "167 St",
  "414": "161 St-Yankee Stadium",
  "414N": "161 St-Yankee Stadium",
  "414S": "161 St-Yankee Stadium",
  "415": "149 St-Grand Concourse",
  "415N": "149 St-Grand Concourse",
  "415S": "149 St-Grand Concourse",
  "416": "138 St-Grand Concourse",
  "416N": "138 St-Grand Concourse",
  "416S": "138 St-Grand Concourse",
  "418": "Fulton St",
  "418N": "Fulton St",
  "418S": "Fulton St",
  "419": "Wall St",
  "419N": "Wall St",
  "419S": "Wall St",
  "420": "Bowling Green",
  "420N": "Bowling Green",
  "420S": "Bowling Green",
  "423": "Borough Hall",
  "423N": "Borough Hall",
  "423S": "Borough Hall",
  "501": "Eastchester-Dyre Av",
  "501N": "Eastchester-Dyre Av",
  "501S": "Eastchester-Dyre Av",
  "502": "Baychester Av",
  "502N": "Baychester Av",
  "502S": "Baychester Av",
  "503": "Gun Hill Rd",
  "503N": "Gun Hill Rd",
  "503S": "Gun Hill Rd",
  "504": "Pelham Pkwy",
  "504N": "Pelham Pkwy",
  "504S": "Pelham Pkwy",
  "505": "Morris Park",
  "505N": "Morris Park",
  "505S": "Morris Park",
  "601": "Pelham Bay Park",
  "601N": "Pelham Bay Park",
  "601S": "Pelham Bay Park",
  "602": "Buhre Av",
  "602N": "Buhre Av",
  "602S": "Buhre Av",
  "603": "Middletown Rd",
  "603N": "Middletown Rd",
  "603S": "Middletown Rd",
  "604": "Westchester Sq-E Tremont Av",
  "604N": "Westchester Sq-E Tremont Av",
  "604S": "Westchester Sq-E Tremont Av",
  "606": "Zerega Av",
  "606N": "Zerega Av",
  "606S": "Zerega Av",
  "607": "Castle Hill Av",
  "607N": "Castle Hill Av",
  "607S": "Castle Hill Av",
  "608": "Parkchester",
  "608N": "Parkchester",
  "608S": "Parkchester",
  "609": "St Lawrence Av",
  "609N": "St Lawrence Av",
  "609S": "St Lawrence Av",
  "610": "Morrison Av-Soundview",
  "610N": "Morrison Av-Soundview",
  "610S": "Morrison Av-Soundview",
  "611": "Elder Av",
  "611N": "Elder Av",
  "611S": "Elder Av",
  "612": "Whitlock Av",
  "612N": "Whitlock Av",
  "612S": "Whitlock Av",
  "613": "Hunts Point Av",
  "613N": "Hunts Point Av",
  "613S": "Hunts Point Av",
  "614": "Longwood Av",
  "614N": "Longwood Av",
  "614S": "Longwood Av",
  "615": "E 149 St",
  "615N": "E 149 St",
  "615S": "E 149 St",
  "616": "E 143 St-St Mary's St",
  "616N": "E 143 St-St Mary's St",
  "616S": "E 143 St-St Mary's St",
  "617": "Cypress Av",
  "617N": "Cypress Av",
  "617S": "Cypress Av",
  "618": "Brook Av",
  "618N": "Brook Av",
  "618S": "Brook Av",
  "619": "3 Av-138 St",
  "619N": "3 Av-138 St",
  "619S": "3 Av-138 St",
  "621": "125 St",
  "621N": "125 St",
  "621S": "125 St",
  "622": "116 St",
  "622N": "116 St",
  "622S": "116 St",
  "623": "110 St",
  "623N": "110 St",
  "623S": "110 St",
  "624": "103 St",
  "624N": "103 St",
  "624S": "103 St",
  "625": "96 St",
  "625N": "96 St",
  "625S": "96 St",
  "626": "86 St",
  "626N": "86 St",
  "626S": "86 St",
  "627": "77 St",
  "627N": "77 St",
  "627S": "77 St",
  "628": "68 St-Hunter College",
  "628N": "68 St-Hunter College",
  "628S": "68 St-Hunter College",
  "629": "59 St",
  "629N": "59 St",
  "629S": "59 St",
  "630": "51 St",
  "630N": "51 St",
  "630S": "51 St",
  "631": "Grand Central-42 St",
  "631N": "Grand Central-42 St",
  "631S": "Grand Central-42 St",
  "632": "33 St",
  "632N": "33 St",
  "632S": "33 St",
  "633": "28 St",
  "633N": "28 St",
  "633S": "28 St",
  "634": "23 St",
  "634N": "23 St",
  "634S": "23 St",
  "635": "14 St-Union Sq",
  "635N": "14 St-Union Sq",
  "635S": "14 St-Union Sq",
  "636": "Astor Pl",
  "636N": "Astor Pl",
  "636S": "Astor Pl",
  "637": "Bleecker St",
  "637N": "Bleecker St",
  "637S": "Bleecker St",
  "638": "Spring St",
  "638N": "Spring St",
  "638S": "Spring St",
  "639": "Canal St",
  "639N": "Canal St",
  "639S": "Canal St",
  "640": "Brooklyn Bridge-City Hall",
  "640N": "Brooklyn Bridge-City Hall",
  "640S": "Brooklyn Bridge-City Hall",
  "701": "Flushing-Main St",
  "701N": "Flushing-Main St",
  "701S": "Flushing-Main St",
  "702": "Mets-Willets Point",
  "702N": "Mets-Willets Point",
  "702S": "Mets-Willets Point",
  "705": "111 St",
  "705N": "111 St",
  "705S": "111 St",
  "706": "103 St-Corona Plaza",
  "706N": "103 St-Corona Plaza",
  "706S": "103 St-Corona Plaza",
  "707": "Junction Blvd",
  "707N": "Junction Blvd",
  "707S": "Junction Blvd",
  "708": "90 St-Elmhurst Av",
  "708N": "90 St-Elmhurst Av",
  "708S": "90 St-Elmhurst Av",
  "709": "82 St-Jackson Hts",
  "709N": "82 St-Jackson Hts",
  "709S": "82 St-Jackson Hts",
  "710": "74 St-Broadway",
  "710N": "74 St-Broadway",
  "710S": "74 St-Broadway",
  "711": "69 St",
  "711N": "69 St",
  "711S": "69 St",
  "712": "61 St-Woodside",
  "712N": "61 St-Woodside",
  "712S": "61 St-Woodside",
  "713": "52 St",
  "713N": "52 St",
  "713S": "52 St",
  "714": "46 St-Bliss St",
  "714N": "46 St-Bliss St",
  "714S": "46 St-Bliss St",
  "715": "40 St-Lowery St",
  "715N": "40 St-Lowery St",
  "715S": "40 St-Lowery St",
  "716": "33 St-Rawson St",
  "716N": "33 St-Rawson St",
  "716S": "33 St-Rawson St",
  "718": "Queensboro Plaza",
  "718N": "Queensboro Plaza",
  "718S": "Queensboro Plaza",
  "719": "Court Sq",
  "719N": "Court Sq",
  "719S": "Court Sq",
  "720": "Hunters Point Av",
  "720N": "Hunters Point Av",
  "720S": "Hunters Point Av",
  "721": "Vernon Blvd-Jackson Av",
  "721N": "Vernon Blvd-Jackson Av",
  "721S": "Vernon Blvd-Jackson Av",
  "723": "Grand Central-42 St",
  "723N": "Grand Central-42 St",
  "723S": "Grand Central-42 St",
  "724": "5 Av",
  "724N": "5 Av",
  "724S": "5 Av",
  "725": "Times Sq-42 St",
  "725N": "Times Sq-42 St",
  "725S": "Times Sq-42 St",
  "726": "34 St-Hudson Yards",
  "726N": "34 St-Hudson Yards",
  "726S": "34 St-Hudson Yards",
  "901": "Grand Central-42 St",
  "901N": "Grand Central-42 St",
  "901S": "Grand Central-42 St",
  "902": "Times Sq-42 St",
  "902N": "Times Sq-42 St",
  "902S": "Times Sq-42 St",
  "A02": "Inwood-207 St",
  "A02N": "Inwood-207 St",
  "A02S": "Inwood-207 St",
  "A03": "Dyckman St",
  "A03N": "Dyckman St",
  "A03S": "Dyckman St",
  "A05": "190 St",
  "A05N": "190 St",
  "A05S": "190 St",
  "A06": "181 St",
  "A06N": "181 St",
  "A06S": "181 St",
  "A07": "175 St",
  "A07N": "175 St",
  "A07S": "175 St",
  "A09": "168 St",
  "A09N": "168 St",
  "A09S": "168 St",
  "A10": "163 St-Amsterdam Av",
  "A10N": "163 St-Amsterdam Av",
  "A10S": "163 St-Amsterdam Av",
  "A11": "155 St",
  "A11N": "155 St",
  "A11S": "155 St",
  "A12": "145 St",
  "A12N": "145 St",
  "A12S": "145 St",
  "A14": "135 St",
  "A14N": "135 St",
  "A14S": "135 St",
  "A15": "125 St",
  "A15N": "125 St",
  "A15S": "125 St",
  "A16": "116 St",
  "A16N": "116 St",
  "A16S": "116 St",
  "A17": "Cathedral Pkwy(110 St)",
  "A17N": "Cathedral Pkwy(110 St)",
  "A17S": "Cathedral Pkwy(110 St)",
  "A18": "103 St",
  "A18N": "103 St",
  "A18S": "103 St",
  "A19": "96 St",
  "A19N": "96 St",
  "A19S": "96 St",
  "A20": "86 St",
  "A20N": "86 St",
  "A20S": "86 St",
  "A21": "81 St-Museum of Natural History",
  "A21N": "81 St-Museum of Natural History",
  "A21S": "81 St-Museum of Natural History",
  "A22": "72 St",
  "A22N": "72 St",
  "A22S": "72 St",
  "A24": "59 St-Columbus Circle",
  "A24N": "59 St-Columbus Circle",
  "A24S": "59 St-Columbus Circle",
  "A25": "50 St",
  "A25N": "50 St",
  "A25S": "50 St",
  "A27": "42 St-Port Authority Bus Terminal",
  "A27N": "42 St-Port Authority Bus Terminal",
  "A27S": "42 St-Port Authority Bus Terminal",
  "A28": "34 St-Penn Station",
  "A28N": "34 St-Penn Station",
  "A28S": "34 St-Penn Station",
  "A30": "23 St",
  "A30N": "23 St",
  "A30S": "23 St",
  "A31": "14 St",
  "A31N": "14 St",
  "A31S": "14 St",
  "A32": "W 4 St-Wash Sq",
  "A32N": "W 4 St-Wash Sq",
  "A32S": "W 4 St-Wash Sq",
  "A33": "Spring St",
  "A33N": "Spring St",
  "A33S": "Spring St",
  "A34": "Canal St",
  "A34N": "Canal St",
  "A34S": "Canal St",
  "A36": "Chambers St",
  "A36N": "Chambers St",
  "A36S": "Chambers St",
  "A38": "Fulton St",
  "A38N": "Fulton St",
  "A38S": "Fulton St",
  "A40": "High St",
  "A40N": "High St",
  "A40S": "High St",
  "A41": "Jay St-MetroTech",
  "A41N": "Jay St-MetroTech",
  "A41S": "Jay St-MetroTech",
  "A42": "Hoyt-Schermerhorn Sts",
  "A42N": "Hoyt-Schermerhorn Sts",
  "A42S": "Hoyt-Schermerhorn Sts",
  "A43": "Lafayette Av",
  "A43N": "Lafayette Av",
  "A43S": "Lafayette Av",
  "A44": "Clinton-Washington Avs",
  "A44N": "Clinton-Washington Avs",
  "A44S": "Clinton-Washington Avs",
  "A45": "Franklin Av",
  "A45N": "Franklin Av",
  "A45S": "Franklin Av",
  "A46": "Nostrand Av",
  "A46N": "Nostrand Av",
  "A46S": "Nostrand Av",
  "A47": "Kingston-Throop Avs",
  "A47N": "Kingston-Throop Avs",
  "A47S": "Kingston-Throop Avs",
  "A48": "Utica Av",
  "A48N": "Utica Av",
  "A48S": "Utica Av",
  "A49": "Ralph Av",
  "A49N": "Ralph Av",
  "A49S": "Ralph Av",
  "A50": "Rockaway Av",
  "A50N": "Rockaway Av",
  "A50S": "Rockaway Av",
  "A51": "Broadway Junction",
  "A51N": "Broadway Junction",
  "A51S": "Broadway Junction",
  "A52": "Liberty Av",
  "A52N": "Liberty Av",
  "A52S": "Liberty Av",
  "A53": "Van Siclen Av",
  "A53N": "Van Siclen Av",
  "A53S": "Van Siclen Av",
  "A54": "Shepherd Av",
  "A54N": "Shepherd Av",
  "A54S": "Shepherd Av",
  "A55": "Euclid Av",
  "A55N": "Euclid Av",
  "A55S": "Euclid Av",
  "A57": "Grant Av",
  "A57N": "Grant Av",
  "A57S": "Grant Av",
  "A59": "80 St",
  "A59N": "80 St",
  "A59S": "80 St",
  "A60": "88 St",
  "A60N": "88 St",
  "A60S": "88 St",
  "A61": "Rockaway Blvd",
  "A61N": "Rockaway Blvd",
  "A61S": "Rockaway Blvd",
  "A63": "104 St",
  "A63N": "104 St",
  "A63S": "104 St",
  "A64": "111 St",
  "A64N": "111 St",
  "A64S": "111 St",
  "A65": "Ozone Park-Lefferts Blvd",
  "A65N": "Ozone Park-Lefferts Blvd",
  "A65S": "Ozone Park-Lefferts Blvd",
  "B04": "21 St-Queensbridge",
  "B04N": "21 St-Queensbridge",
  "B04S": "21 St-Queensbridge",
  "B06": "Roosevelt Island",
  "B06N": "Roosevelt Island",
  "B06S": "Roosevelt Island",
  "B08": "Lexington Av / 63 St",
  "B08N": "Lexington Av / 63 St",
  "B08S": "Lexington Av / 63 St",
  "B10": "57 St",
  "B10N": "57 St",
  "B10S": "57 St",
  "B12": "9 Av",
  "B12N": "9 Av",
  "B12S": "9 Av",
  "B13": "Fort Hamilton Pkwy",
  "B13N": "Fort Hamilton Pkwy",
  "B13S": "Fort Hamilton Pkwy",
  "B14": "50 St",
  "B14N": "50 St",
  "B14S": "50 St",
  "B15": "55 St",
  "B15N": "55 St",
  "B15S": "55 St",
  "B16": "62 St",
  "B16N": "62 St",
  "B16S": "62 St",
  "B17": "71 St",
  "B17N": "71 St",
  "B17S": "71 St",
  "B18": "79 St",
  "B18N": "79 St",
  "B18S": "79 St",
  "B19": "18 Av",
  "B19N": "18 Av",
  "B19S": "18 Av",
  "B20": "20 Av",
  "B20N": "20 Av",
  "B20S": "20 Av",
  "B21": "Bay Pkwy",
  "B21N": "Bay Pkwy",
  "B21S": "Bay Pkwy",
  "B22": "25 Av",
  "B22N": "25 Av",
  "B22S": "25 Av",
  "B23": "Bay 50 St",
  "B23N": "Bay 50 St",
  "B23S": "Bay 50 St",
  "D01": "Norwood-205 St",
  "D01N": "Norwood-205 St",
  "D01S": "Norwood-205 St",
  "D03": "Bedford Park Blvd",
  "D03N": "Bedford Park Blvd",
  "D03S": "Bedford Park Blvd",
  "D04": "Kingsbridge Rd",
  "D04N": "Kingsbridge Rd",
  "D04S": "Kingsbridge Rd",
  "D05": "Fordham Rd",
  "D05N": "Fordham Rd",
  "D05S": "Fordham Rd",
  "D06": "182-183 Sts",
  "D06N": "182-183 Sts",
  "D06S": "182-183 Sts",
  "D07": "Tremont Av",
  "D07N": "Tremont Av",
  "D07S": "Tremont Av",
  "D08": "174-175 Sts",
  "D08N": "174-175 Sts",
  "D08S": "174-175 Sts",
  "D09": "170 St",
  "D09N": "170 St",
  "D09S": "170 St",
  "D10": "167 St",
  "D10N": "167 St",
  "D10S": "167 St",
  "D11": "161 St-Yankee Stadium",
  "D11N": "161 St-Yankee Stadium",
  "D11S": "161 St-Yankee Stadium",
  "D12": "155 St",
  "D12N": "155 St",
  "D12S": "155 St",
  "D13": "145 St",
  "D13N": "145 St",
  "D13S": "145 St",
  "D14": "7 Av",
  "D14N": "7 Av",
  "D14S": "7 Av",
  "D15": "47-50 Sts-Rockefeller Ctr",
  "D15N": "47-50 Sts-Rockefeller Ctr",
  "D15S": "47-50 Sts-Rockefeller Ctr",
  "D16": "42 St-Bryant Pk",
  "D16N": "42 St-Bryant Pk",
  "D16S": "42 St-Bryant Pk",
  "D17": "34 St-Herald Sq",
  "D17N": "34 St-Herald Sq",
  "D17S": "34 St-Herald Sq",
  "D18": "23 St",
  "D18N": "23 St",
  "D18S": "23 St",
  "D19": "14 St",
  "D19N": "14 St",
  "D19S": "14 St",
  "D20": "W 4 St-Wash Sq",
  "D20N": "W 4 St-Wash Sq",
  "D20S": "W 4 St-Wash Sq",
  "D21": "Broadway-Lafayette St",
  "D21N": "Broadway-Lafayette St",
  "D21S": "Broadway-Lafayette St",
  "D22": "Grand St",
  "D22N": "Grand St",
  "D22S": "Grand St",
  "D24": "Atlantic Av-Barclays Ctr",
  "D24N": "Atlantic Av-Barclays Ctr",
  "D24S": "Atlantic Av-Barclays Ctr",
  "D25": "7 Av",
  "D25N": "7 Av",
  "D25S": "7 Av",
  "D26": "Prospect Park",
  "D26N": "Prospect Park",
  "D26S": "Prospect Park",
  "D27": "Parkside Av",
  "D27N": "Parkside Av",
  "D27S": "Parkside Av",
  "D28": "Church Av",
  "D28N": "Church Av",
  "D28S": "Church Av",
  "D29": "Beverley Rd",
  "D29N": "Beverley Rd",
  "D29S": "Beverley Rd",
  "D30": "Cortelyou Rd",
  "D30N": "Cortelyou Rd",
  "D30S": "Cortelyou Rd",
  "D31": "Newkirk Plaza",
  "D31N": "Newkirk Plaza",
  "D31S": "Newkirk Plaza",
  "D32": "Avenue H",
  "D32N": "Avenue H",
  "D32S": "Avenue H",
  "D33": "Avenue J",
  "D33N": "Avenue J",
  "D33S": "Avenue J",
  "D34": "Avenue M",
  "D34N": "Avenue M",
  "D34S": "Avenue M",
  "D35": "Kings Hwy",
  "D35N": "Kings Hwy",
  "D35S": "Kings Hwy",
  "D37": "Avenue U",
  "D37N": "Avenue U",
  "D37S": "Avenue U",
  "D38": "Neck Rd",
  "D38N": "Neck Rd",
  "D38S": "Neck Rd",
  "D39": "Sheepshead Bay",
  "D39N": "Sheepshead Bay",
  "D39S": "Sheepshead Bay",
  "D40": "Brighton Beach",
  "D40N": "Brighton Beach",
  "D40S": "Brighton Beach",
  "D41": "Ocean Pkwy",
  "D41N": "Ocean Pkwy",
  "D41S": "Ocean Pkwy",
  "D42": "W 8 St-NY Aquarium",
  "D42N": "W 8 St-NY Aquarium",
  "D42S": "W 8 St-NY Aquarium",
  "D43": "Coney Island-Stillwell Av",
  "D43N": "Coney Island-Stillwell Av",
  "D43S": "Coney Island-Stillwell Av",
  "E01": "World Trade Center",
  "E01N": "World Trade Center",
  "E01S": "World Trade Center",
  "F01": "Jamaica-179 St",
  "F01N": "Jamaica-179 St",
  "F01S": "Jamaica-179 St",
  "F02": "169 St",
  "F02N": "169 St",
  "F02S": "169 St",
  "F03": "Parsons Blvd",
  "F03N": "Parsons Blvd",
  "F03S": "Parsons Blvd",
  "F04": "Sutphin Blvd",
  "F04N": "Sutphin Blvd",
  "F04S": "Sutphin Blvd",
  "F05": "Briarwood",
  "F05N": "Briarwood",
  "F05S": "Briarwood",
  "F06": "Kew Gardens-Union Tpke",
  "F06N": "Kew Gardens-Union Tpke",
  "F06S": "Kew Gardens-Union Tpke",
  "F07": "75 Av",
  "F07N": "75 Av",
  "F07S": "75 Av",
  "F09": "Court Sq-23 St",
  "F09N": "Court Sq-23 St",
  "F09S": "Court Sq-23 St",
  "F11": "Lexington Av / 53 St",
  "F11N": "Lexington Av / 53 St",
  "F11S": "Lexington Av / 53 St",
  "F12": "5 Av / 53 St",
  "F12N": "5 Av / 53 St",
  "F12S": "5 Av / 53 St",
  "F14": "2 Av",
  "F14N": "2 Av",
  "F14S": "2 Av",
  "F15": "Delancey St-Essex St",
  "F15N": "Delancey St-Essex St",
  "F15S": "Delancey St-Essex St",
  "F16": "East Broadway",
  "F16N": "East Broadway",
  "F16S": "East Broadway",
  "F18": "York St",
  "F18N": "York St",
  "F18S": "York St",
  "F20": "Bergen St",
  "F20N": "Bergen St",
  "F20S": "Bergen St",
  "F21": "Carroll St",
  "F21N": "Carroll St",
  "F21S": "Carroll St",
  "F22": "Smith-9 Sts",
  "F22N": "Smith-9 Sts",
  "F22S": "Smith-9 Sts",
  "F23": "4 Av-9 St",
  "F23N": "4 Av-9 St",
  "F23S": "4 Av-9 St",
  "F24": "7 Av",
  "F24N": "7 Av",
  "F24S": "7 Av",
  "F25": "15 St-Prospect Park",
  "F25N": "15 St-Prospect Park",
  "F25S": "15 St-Prospect Park",
  "F26": "Fort Hamilton Pkwy",
  "F26N": "Fort Hamilton Pkwy",
  "F26S": "Fort Hamilton Pkwy",
  "F27": "Church Av",
  "F27N": "Church Av",
  "F27S": "Church Av",
  "F29": "Ditmas Av",
  "F29N": "Ditmas Av",
  "F29S": "Ditmas Av",
  "F30": "18 Av",
  "F30N": "18 Av",
  "F30S": "18 Av",
  "F31": "Avenue I",
  "F31N": "Avenue I",
  "F31S": "Avenue I",
  "F32": "Bay Pkwy",
  "F32N": "Bay Pkwy",
  "F32S": "Bay Pkwy",
  "F33": "Avenue N",
  "F33N": "Avenue N",
  "F33S": "Avenue N",
  "F34": "Avenue P",
  "F34N": "Avenue P",
  "F34S": "Avenue P",
  "F35": "Kings Hwy",
  "F35N": "Kings Hwy",
  "F35S": "Kings Hwy",
  "F36": "Avenue U",
  "F36N": "Avenue U",
  "F36S": "Avenue U",
  "F38": "Avenue X",
  "F38N": "Avenue X",
  "F38S": "Avenue X",
  "F39": "Neptune Av",
  "F39N": "Neptune Av",
  "F39S": "Neptune Av",
  "G05": "Jamaica Center-Parsons / Archer",
  "G05N": "Jamaica Center-Parsons / Archer",
  "G05S": "Jamaica Center-Parsons / Archer",
  "G06": "Sutphin Blvd-Archer Av-JFK Airport",
  "G06N": "Sutphin Blvd-Archer Av-JFK Airport",
  "G06S": "Sutphin Blvd-Archer Av-JFK Airport",
  "G07": "Jamaica-Van Wyck",
  "G07N": "Jamaica-Van Wyck",
  "G07S": "Jamaica-Van Wyck",
  "G08": "Forest Hills-71 Av",
  "G08N": "Forest Hills-71 Av",
  "G08S": "Forest Hills-71 Av",
  "G09": "67 Av",
  "G09N": "67 Av",
  "G09S": "67 Av",
  "G10": "63 Dr-Rego Park",
  "G10N": "63 Dr-Rego Park",
  "G10S": "63 Dr-Rego Park",
  "G11": "Woodhaven Blvd",
  "G11N": "Woodhaven Blvd",
  "G11S": "Woodhaven Blvd",
  "G12": "Grand Av-Newtown",
  "G12N": "Grand Av-Newtown",
  "G12S": "Grand Av-Newtown",
  "G13": "Elmhurst Av",
  "G13N": "Elmhurst Av",
  "G13S": "Elmhurst Av",
  "G14": "Jackson Hts-Roosevelt Av",
  "G14N": "Jackson Hts-Roosevelt Av",
  "G14S": "Jackson Hts-Roosevelt Av",
  "G15": "65 St",
  "G15N": "65 St",
  "G15S": "65 St",
  "G16": "Northern Blvd",
  "G16N": "Northern Blvd",
  "G16S": "Northern Blvd",
  "G18": "46 St",
  "G18N": "46 St",
  "G18S": "46 St",
  "G19": "Steinway St",
  "G19N": "Steinway St",
  "G19S": "Steinway St",
  "G20": "36 St",
  "G20N": "36 St",
  "G20S": "36 St",
  "G21": "Queens Plaza",
  "G21N": "Queens Plaza",
  "G21S": "Queens Plaza",
  "G22": "Court Sq",
  "G22N": "Court Sq",
  "G22S": "Court Sq",
  "G24": "21 St",
  "G24N": "21 St",
  "G24S": "21 St",
  "G26": "Greenpoint Av",
  "G26N": "Greenpoint Av",
  "G26S": "Greenpoint Av",
  "G28": "Nassau Av",
  "G28N": "Nassau Av",
  "G28S": "Nassau Av",
  "G29": "Metropolitan Av",
  "G29N": "Metropolitan Av",
  "G29S": "Metropolitan Av",
  "G30": "Broadway",
  "G30N": "Broadway",
  "G30S": "Broadway",
  "G31": "Flushing Av",
  "G31N": "Flushing Av",
  "G31S": "Flushing Av",
  "G32": "Myrtle-Willoughby Avs",
  "G32N": "Myrtle-Willoughby Avs",
  "G32S": "Myrtle-Willoughby Avs",
  "G33": "Bedford-Nostrand Avs",
  "G33N": "Bedford-Nostrand Avs",
  "G33S": "Bedford-Nostrand Avs",
  "G34": "Classon Av",
  "G34N": "Classon Av",
  "G34S": "Classon Av",
  "G35": "Clinton-Washington Avs",
  "G35N": "Clinton-Washington Avs",
  "G35S": "Clinton-Washington Avs",
  "G36": "Fulton St",
  "G36N": "Fulton St",
  "G36S": "Fulton St",
  "H01": "Aqueduct Racetrack",
  "H01N": "Aqueduct Racetrack",
  "H01S": "Aqueduct Racetrack",
  "H02": "Aqueduct-N Conduit Av",
  "H02N": "Aqueduct-N Conduit Av",
  "H02S": "Aqueduct-N Conduit Av",
  "H03": "Howard Beach-JFK Airport",
  "H03N": "Howard Beach-JFK Airport",
  "H03S": "Howard Beach-JFK Airport",
  "H04": "Broad Channel",
  "H04N": "Broad Channel",
  "H04S": "Broad Channel",
  "H06": "Beach 67 St",
  "H06N": "Beach 67 St",
  "H06S": "Beach 67 St",
  "H07": "Beach 60 St",
  "H07N": "Beach 60 St",
  "H07S": "Beach 60 St",
  "H08": "Beach 44 St",
  "H08N": "Beach 44 St",
  "H08S": "Beach 44 St",
  "H09": "Beach 36 St",
  "H09N": "Beach 36 St",
  "H09S": "Beach 36 St",
  "H10": "Beach 25 St",
  "H10N": "Beach 25 St",
  "H10S": "Beach 25 St",
  "H11": "Far Rockaway-Mott Av",
  "H11N": "Far Rockaway-Mott Av",
  "H11S": "Far Rockaway-Mott Av",
  "H12": "Beach 90 St",
  "H12N": "Beach 90 St",
  "H12S": "Beach 90 St",
  "H13": "Beach 98 St",
  "H13N": "Beach 98 St",
  "H13S": "Beach 98 St",
  "H14": "Beach 105 St",
  "H14N": "Beach 105 St",
  "H14S": "Beach 105 St",
  "H15": "Rockaway Park-Beach 116 St",
  "H15N": "Rockaway Park-Beach 116 St",
  "H15S": "Rockaway Park-Beach 116 St",
  "H19": "Broad Channel",
  "H19N": "Broad Channel",
  "H19S": "Broad Channel",
  "J12": "121 St",
  "J12N": "121 St",
  "J12S": "121 St",
  "J13": "111 St",
  "J13N": "111 St",
  "J13S": "111 St",
  "J14": "104 St",
  "J14N": "104 St",
  "J14S": "104 St",
  "J15": "Woodhaven Blvd",
  "J15N": "Woodhaven Blvd",
  "J15S": "Woodhaven Blvd",
  "J16": "85 St-Forest Pkwy",
  "J16N": "85 St-Forest Pkwy",
  "J16S": "85 St-Forest Pkwy",
  "J17": "75 St-Elderts Ln",
  "J17N": "75 St-Elderts Ln",
  "J17S": "75 St-Elderts Ln",
  "J19": "Cypress Hills",
  "J19N": "Cypress Hills",
  "J19S": "Cypress Hills",
  "J20": "Crescent St",
  "J20N": "Crescent St",
  "J20S": "Crescent St",
  "J21": "Norwood Av",
  "J21N": "Norwood Av",
  "J21S": "Norwood Av",
  "J22": "Cleveland St",
  "J22N": "Cleveland St",
  "J22S": "Cleveland St",
  "J23": "Van Siclen Av",
  "J23N": "Van Siclen Av",
  "J23S": "Van Siclen Av",
  "J24": "Alabama Av",
  "J24N": "Alabama Av",
  "J24S": "Alabama Av",
  "J27": "Broadway Junction",
  "J27N": "Broadway Junction",
  "J27S": "Broadway Junction",
  "J28": "Chauncey St",
  "J28N": "Chauncey St",
  "J28S": "Chauncey St",
  "J29": "Halsey St",
  "J29N": "Halsey St",
  "J29S": "Halsey St",
  "J30": "Gates Av",
  "J30N": "Gates Av",
  "J30S": "Gates Av",
  "J31": "Kosciuszko St",
  "J31N": "Kosciuszko St",
  "J31S": "Kosciuszko St",
  "L01": "8 Av",
  "L01N": "8 Av",
  "L01S": "8 Av",
  "L02": "6 Av",
  "L02N": "6 Av",
  "L02S": "6 Av",
  "L03": "14 St-Union Sq",
  "L03N": "14 St-Union Sq",
  "L03S": "14 St-Union Sq",
  "L05": "3 Av",
  "L05N": "3 Av",
  "L05S": "3 Av",
  "L06": "1 Av",
  "L06N": "1 Av",
  "L06S": "1 Av",
  "L08": "Bedford Av",
  "L08N": "Bedford Av",
  "L08S": "Bedford Av",
  "L10": "Lorimer St",
  "L10N": "Lorimer St",
  "L10S": "Lorimer St",
  "L11": "Graham Av",
  "L11N": "Graham Av",
  "L11S": "Graham Av",
  "L12": "Grand St",
  "L12N": "Grand St",
  "L12S": "Grand St",
  "L13": "Montrose Av",
  "L13N": "Montrose Av",
  "L13S": "Montrose Av",
  "L14": "Morgan Av",
  "L14N": "Morgan Av",
  "L14S": "Morgan Av",
  "L15": "Jefferson St",
  "L15N": "Jefferson St",
  "L15S": "Jefferson St",
  "L16": "DeKalb Av",
  "L16N": "DeKalb Av",
  "L16S": "DeKalb Av",
  "L17": "Myrtle-Wyckoff Avs",
  "L17N": "Myrtle-Wyckoff Avs",
  "L17S": "Myrtle-Wyckoff Avs",
  "L19": "Halsey St",
  "L19N": "Halsey St",
  "L19S": "Halsey St",
  "L20": "Wilson Av",
  "L20N": "Wilson Av",
  "L20S": "Wilson Av",
  "L21": "Bushwick Av-Aberdeen St",
  "L21N": "Bushwick Av-Aberdeen St",
  "L21S": "Bushwick Av-Aberdeen St",
  "L22": "Broadway Junction",
  "L22N": "Broadway Junction",
  "L22S": "Broadway Junction",
  "L24": "Atlantic Av",
  "L24N": "Atlantic Av",
  "L24S": "Atlantic Av",
  "L25": "Sutter Av",
  "L25N": "Sutter Av",
  "L25S": "Sutter Av",
  "L26": "Livonia Av",
  "L26N": "Livonia Av",
  "L26S": "Livonia Av",
  "L27": "New Lots Av",
  "L27N": "New Lots Av",
  "L27S": "New Lots Av",
  "L28": "East 105 St",
  "L28N": "East 105 St",
  "L28S": "East 105 St",
  "L29": "Canarsie-Rockaway Pkwy",
  "L29N": "Canarsie-Rockaway Pkwy",
  "L29S": "Canarsie-Rockaway Pkwy",
  "M01": "Middle Village-Metropolitan Av",
  "M01N": "Middle Village-Metropolitan Av",
  "M01S": "Middle Village-Metropolitan Av",
  "M04": "Fresh Pond Rd",
  "M04N": "Fresh Pond Rd",
  "M04S": "Fresh Pond Rd",
  "M05": "Forest Av",
  "M05N": "Forest Av",
  "M05S": "Forest Av",
  "M06": "Seneca Av",
  "M06N": "Seneca Av",
  "M06S": "Seneca Av",
  "M08": "Myrtle-Wyckoff Avs",
  "M08N": "Myrtle-Wyckoff Avs",
  "M08S": "Myrtle-Wyckoff Avs",
  "M09": "Knickerbocker Av",
  "M09N": "Knickerbocker Av",
  "M09S": "Knickerbocker Av",
  "M10": "Central Av",
  "M10N": "Central Av",
  "M10S": "Central Av",
  "M11": "Myrtle Av",
  "M11N": "Myrtle Av",
  "M11S": "Myrtle Av",
  "M12": "Flushing Av",
  "M12N": "Flushing Av",
  "M12S": "Flushing Av",
  "M13": "Lorimer St",
  "M13N": "Lorimer St",
  "M13S": "Lorimer St",
  "M14": "Hewes St",
  "M14N": "Hewes St",
  "M14S": "Hewes St",
  "M16": "Marcy Av",
  "M16N": "Marcy Av",
  "M16S": "Marcy Av",
  "M18": "Delancey St-Essex St",
  "M18N": "Delancey St-Essex St",
  "M18S": "Delancey St-Essex St",
  "M19": "Bowery",
  "M19N": "Bowery",
  "M19S": "Bowery",
  "M20": "Canal St",
  "M20N": "Canal St",
  "M20S": "Canal St",
  "M21": "Chambers St",
  "M21N": "Chambers St",
  "M21S": "Chambers St",
  "M22": "Fulton St",
  "M22N": "Fulton St",
  "M22S": "Fulton St",
  "M23": "Broad St",
  "M23N": "Broad St",
  "M23S": "Broad St",
  "N02": "8 Av",
  "N02N": "8 Av",
  "N02S": "8 Av",
  "N03": "Fort Hamilton Pkwy",
  "N03N": "Fort Hamilton Pkwy",
  "N03S": "Fort Hamilton Pkwy",
  "N04": "New Utrecht Av",
  "N04N": "New Utrecht Av",
  "N04S": "New Utrecht Av",
  "N05": "18 Av",
  "N05N": "18 Av",
  "N05S": "18 Av",
  "N06": "20 Av",
  "N06N": "20 Av",
  "N06S": "20 Av",
  "N07": "Bay Pkwy",
  "N07N": "Bay Pkwy",
  "N07S": "Bay Pkwy",
  "N08": "Kings Hwy",
  "N08N": "Kings Hwy",
  "N08S": "Kings Hwy",
  "N09": "Avenue U",
  "N09N": "Avenue U",
  "N09S": "Avenue U",
  "N10": "86 St",
  "N10N": "86 St",
  "N10S": "86 St",
  "N12": "S.B.Coney Island",
  "N12N": "S.B.Coney Island",
  "N12S": "S.B.Coney Island",
  "Q01": "Canal St",
  "Q01N": "Canal St",
  "Q01S": "Canal St",
  "Q03": "72 St",
  "Q03N": "72 St",
  "Q03S": "72 St",
  "Q04": "86 St",
  "Q04N": "86 St",
  "Q04S": "86 St",
  "Q05": "96 St",
  "Q05N": "96 St",
  "Q05S": "96 St",
  "R01": "Astoria-Ditmars Blvd",
  "R01N": "Astoria-Ditmars Blvd",
  "R01S": "Astoria-Ditmars Blvd",
  "R03": "Astoria Blvd",
  "R03N": "Astoria Blvd",
  "R03S": "Astoria Blvd",
  "R04": "30 Av",
  "R04N": "30 Av",
  "R04S": "30 Av",
  "R05": "Broadway",
  "R05N": "Broadway",
  "R05S": "Broadway",
  "R06": "36 Av",
  "R06N": "36 Av",
  "R06S": "36 Av",
  "R08": "39 Av-Dutch Kills",
  "R08N": "39 Av-Dutch Kills",
  "R08S": "39 Av-Dutch Kills",
  "R09": "Queensboro Plaza",
  "R09N": "Queensboro Plaza",
  "R09S": "Queensboro Plaza",
  "R11": "Lexington Av / 59 St",
  "R11N": "Lexington Av / 59 St",
  "R11S": "Lexington Av / 59 St",
  "R13": "5 Av / 59 St",
  "R13N": "5 Av / 59 St",
  "R13S": "5 Av / 59 St",
  "R14": "57 St-7 Av",
  "R14N": "57 St-7 Av",
  "R14S": "57 St-7 Av",
  "R15": "49 St",
  "R15N": "49 St",
  "R15S": "49 St",
  "R16": "Times Sq-42 St",
  "R16N": "Times Sq-42 St",
  "R16S": "Times Sq-42 St",
  "R17": "34 St-Herald Sq",
  "R17N": "34 St-Herald Sq",
  "R17S": "34 St-Herald Sq",
  "R18": "28 St",
  "R18N": "28 St",
  "R18S": "28 St",
  "R19": "23 St",
  "R19N": "23 St",
  "R19S": "23 St",
  "R20": "14 St-Union Sq",
  "R20N": "14 St-Union Sq",
  "R20S": "14 St-Union Sq",
  "R21": "8 St-NYU",
  "R21N": "8 St-NYU",
  "R21S": "8 St-NYU",
  "R22": "Prince St",
  "R22N": "Prince St",
  "R22S": "Prince St",
  "R23": "Canal St",
  "R23N": "Canal St",
  "R23S": "Canal St",
  "R24": "City Hall",
  "R24N": "City Hall",
  "R24S": "City Hall",
  "R25": "Cortlandt St",
  "R25N": "Cortlandt St",
  "R25S": "Cortlandt St",
  "R26": "Rector St",
  "R26N": "Rector St",
  "R26S": "Rector St",
  "R27": "Whitehall St-South Ferry",
  "R27N": "Whitehall St-South Ferry",
  "R27S": "Whitehall St-South Ferry",
  "R28": "Court St",
  "R28N": "Court St",
  "R28S": "Court St",
  "R29": "Jay St-MetroTech",
  "R29N": "Jay St-MetroTech",
  "R29S": "Jay St-MetroTech",
  "R30": "DeKalb Av",
  "R30N": "DeKalb Av",
  "R30S": "DeKalb Av",
  "R31": "Atlantic Av-Barclays Ctr",
  "R31N": "Atlantic Av-Barclays Ctr",
  "R31S": "Atlantic Av-Barclays Ctr",
  "R32": "Union St",
  "R32N": "Union St",
  "R32S": "Union St",
  "R33": "4 Av-9 St",
  "R33N": "4 Av-9 St",
  "R33S": "4 Av-9 St",
  "R34": "Prospect Av",
  "R34N": "Prospect Av",
  "R34S": "Prospect Av",
  "R35": "25 St",
  "R35N": "25 St",
  "R35S": "25 St",
  "R36": "36 St",
  "R36N": "36 St",
  "R36S": "36 St",
  "R39": "45 St",
  "R39N": "45 St",
  "R39S": "45 St",
  "R40": "53 St",
  "R40N": "53 St",
  "R40S": "53 St",
  "R41": "59 St",
  "R41N": "59 St",
  "R41S": "59 St",
  "R42": "Bay Ridge Av",
  "R42N": "Bay Ridge Av",
  "R42S": "Bay Ridge Av",
  "R43": "77 St",
  "R43N": "77 St",
  "R43S": "77 St",
  "R44": "86 St",
  "R44N": "86 St",
  "R44S": "86 St",
  "R45": "Bay Ridge-95 St",
  "R45N": "Bay Ridge-95 St",
  "R45S": "Bay Ridge-95 St",
  "S01": "Franklin Av",
  "S01N": "Franklin Av",
  "S01S": "Franklin Av",
  "S03": "Park Pl",
  "S03N": "Park Pl",
  "S03S": "Park Pl",
  "S04": "Botanic Garden",
  "S04N": "Botanic Garden",
  "S04S": "Botanic Garden",
  "S09": "Tottenville",
  "S09N": "Tottenville",
  "S09S": "Tottenville",
  "S11": "Arthur Kill",
  "S11N": "Arthur Kill",
  "S11S": "Arthur Kill",
  "S13": "Richmond Valley",
  "S13N": "Richmond Valley",
  "S13S": "Richmond Valley",
  "S14": "Pleasant Plains",
  "S14N": "Pleasant Plains",
  "S14S": "Pleasant Plains",
  "S15": "Prince's Bay",
  "S15N": "Prince's Bay",
  "S15S": "Prince's Bay",
  "S16": "Huguenot",
  "S16N": "Huguenot",
  "S16S": "Huguenot",
  "S17": "Annadale",
  "S17N": "Annadale",
  "S17S": "Annadale",
  "S18": "Eltingville",
  "S18N": "Eltingville",
  "S18S": "Eltingville",
  "S19": "Great Kills",
  "S19N": "Great Kills",
  "S19S": "Great Kills",
  "S20": "Bay Terrace",
  "S20N": "Bay Terrace",
  "S20S": "Bay Terrace",
  "S21": "Oakwood Heights",
  "S21N": "Oakwood Heights",
  "S21S": "Oakwood Heights",
  "S22": "New Dorp",
  "S22N": "New Dorp",
  "S22S": "New Dorp",
  "S23": "Grant City",
  "S23N": "Grant City",
  "S23S": "Grant City",
  "S24": "Jefferson Av",
  "S24N": "Jefferson Av",
  "S24S": "Jefferson Av",
  "S25": "Dongan Hills",
  "S25N": "Dongan Hills",
  "S25S": "Dongan Hills",
  "S26": "Old Town",
  "S26N": "Old Town",
  "S26S": "Old Town",
  "S27": "Grasmere",
  "S27N": "Grasmere",
  "S27S": "Grasmere",
  "S28": "Clifton",
  "S28N": "Clifton",
  "S28S": "Clifton",
  "S29": "Stapleton",
  "S29N": "Stapleton",
  "S29S": "Stapleton",
  "S30": "Tompkinsville",
  "S30N": "Tompkinsville",
  "S30S": "Tompkinsville",
  "S31": "St George",
  "S31N": "St George",
  "S31S": "St George"
};
